import React from 'react';
import "./LabeledFrameModule.scss"
import { formatVideoSeconds } from "../../../../utility/formatters";

// Shows frame labels near their frame time
function LabeledFrameModule({ data, annotations, progress, videoRef, setPlaying, duration }) {
    // data: [{ video_time: float, label: str }]
    const data_preview = <svg width="100%" height="20px" style={{"marginBottom": "-9px"}}>
        {/* Narration Points */}
        {
            duration && data.map((seg, i) => <rect x={`${(seg.video_time / duration)*100}%`} y={6} width={1} height='10px' fill='black' opacity={0.4} key={i} />)
        }

        {/* Seeker */}
        <svg x={`${(progress)/duration * 100}%`} style={{overflow:'visible', opacity:0.8, pointerEvents:'none'}}>
            <polygon points="0,5 5,0 -5,0" fill="var(--app-primaryColor)"/>
            <rect  x={-0.5} width={1} height='15' fill='var(--app-primaryColor)'/>
            <rect  x={-0.25} y={0} width={0.5} height='4' fill='white'/>
        </svg>
    </svg>

    return <>
        {data_preview}
        <div className="labeled-frame-module">{
            data.filter((seg) => (
                (seg.video_time > progress && (seg.video_time - progress) <= 0.3)
                || (progress > seg.video_time && (progress - seg.video_time) <= 0.7)
            ))
                .map((seg, i) => <div className='label' key={i}><span style={{"color": "gray"}}>{formatVideoSeconds(seg.video_time)}</span> {seg.label}</div>)
        }</div>
    </>
}

export { LabeledFrameModule };